export default __webpack_public_path__ + "static/media/ESG.debee7e6.jpg";